// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-add[data-v-29795ae8] {\n    margin-top: 16px;\n}\n@media (min-width: 992px) {\n.btn-add[data-v-29795ae8] {\n        margin-top: 0;\n}\n}\n", ""]);
// Exports
module.exports = exports;
